

(function() {
  const MAX_HISTORY = 6;
  const STORAGE_KEY = '__srch_history';

  const section = document.querySelector('.predictive-search__section');
  const list = document.getElementById('recent-search-list');
  const clearBtn = document.getElementById('clear-history-btn');

  if (!section || !list || !clearBtn) return;

  function getHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveKeyword(keyword) {
    if (!keyword.trim()) return;
    let history = getHistory();
    history = history.filter(k => k.toLowerCase() !== keyword.toLowerCase());
    history.unshift(keyword.trim());
    history = history.slice(0, MAX_HISTORY);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  }

  function renderHistory() {
    const history = getHistory();
    list.innerHTML = '';
    if (history.length === 0) {
      section.style.display = 'none';
      return;
    }

    section.style.display = 'block';
    history.forEach(keyword => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `/search?q=${encodeURIComponent(keyword)}`;
      a.textContent = keyword;
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  clearBtn.addEventListener('click', () => {
    localStorage.removeItem(STORAGE_KEY);
    renderHistory();
  });

  const searchForm = document.querySelector('form[action="/search"]');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      const input = searchForm.querySelector('input[name="q"]');
      if (input && input.value) {
        saveKeyword(input.value);
      }
    });
  }

  renderHistory();
})();

function updateBannerPosition() {
  const banner1 = document.querySelector('div.banner__box.banner__box--template--18006315696170__image_banner_gMcTwm');
  const banner2 = document.querySelector('div.banner__box.banner__box--template--17901069336618__image_banner_MfCGCd');
  const banner3 = document.querySelector('div.banner__box.banner__box--template--18006315696170__image_banner_FmPAQ8');
  const banner4 = document.querySelector('div.banner__box.banner__box--template--17901070024746__image_banner_rQ9UAe');
  const banner5 = document.querySelector('div.banner__text.banner__text--template--17901070024746__image_banner_rQ9UAe');


  if (window.innerWidth <= 768) {
    if (banner1) {
      banner1.style.position = 'absolute';
      banner1.style.top = '-160px';
    }
    if (banner2) {
      banner2.style.position = 'absolute';
      banner2.style.top = '-770px';
    }
    if (banner3) {
      banner3.style.position = 'absolute';
      banner3.style.top = '-430px';
    }
    if (banner4) {
      banner4.style.position = 'absolute';
      banner4.style.top = '-300px';
    }
    if (banner5) {
      banner5.style.marginTop = '10px';
    }
  } else {
    if (banner1) {
      banner1.style.position = '';
      banner1.style.top = '';
    }
    if (banner2) {
      banner2.style.position = '';
      banner2.style.top = '';
    }
    if (banner3) {
      banner3.style.position = '';
      banner3.style.top = '';
    }
    if (banner4) {
      banner4.style.position = '';
      banner4.style.top = '';
    }
    if (banner5) {
      banner5.style.marginTop = '';
    }
  }
}

window.addEventListener('DOMContentLoaded', updateBannerPosition);
window.addEventListener('resize', updateBannerPosition);



document.addEventListener("DOMContentLoaded", function () {
  const collapseLinks = document.querySelectorAll(".footer-block__collapse-link");

  if (!collapseLinks.length) return;

  function getContent(block) {
    return block ? block.querySelector(".footer-block__details-content") : null;
  }

  // 关闭一个 block（带高度动画）
  function closeBlock(block) {
    const content = getContent(block);
    if (!content) return;

    const currentHeight = content.offsetHeight;
    if (!currentHeight) {
      block.removeAttribute("open");
      return;
    }

    content.style.height = currentHeight + "px";
    // 触发重绘
    content.offsetHeight;
    content.style.height = "0px";

    block.removeAttribute("open");
  }

  // 打开一个 block（带高度动画）
  function openBlock(block) {
    const content = getContent(block);
    if (!content) return;

    content.style.height = "auto";
    const targetHeight = content.offsetHeight;

    content.style.height = "0px";
    // 触发重绘
    content.offsetHeight;
    content.style.height = targetHeight + "px";

    block.setAttribute("open", "true");
  }

  collapseLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      // 只在移动端生效
      if (window.innerWidth >= 768) return;

      event.preventDefault();

      const currentBlock = link.closest("footer-collapse-block");
      if (!currentBlock) return;

      const isOpen = currentBlock.hasAttribute("open");

      // 先收起所有已打开的
      document.querySelectorAll("footer-collapse-block[open]").forEach(function (block) {
        if (block !== currentBlock) {
          closeBlock(block);
        }
      });

      // 再根据当前状态选择打开或关闭
      if (isOpen) {
        closeBlock(currentBlock);
      } else {
        openBlock(currentBlock);
      }
    });
  });

  // 初始化：如果有默认展开的（例如配置 open_first_collapsible_row），同步高度
  document.querySelectorAll("footer-collapse-block[open]").forEach(function (block) {
    const content = getContent(block);
    if (!content) return;

    content.style.height = "auto";
    const targetHeight = content.offsetHeight;
    content.style.height = targetHeight + "px";
  });
});


document.addEventListener('DOMContentLoaded', function() {
    const allShopCardButtons = document.querySelectorAll('.new-shop-card-btn');

    const targetIndex = 6; // 0-indexed for the 7th element

    if (allShopCardButtons.length > targetIndex) {
        const seventhButton = allShopCardButtons[targetIndex];

        seventhButton.style.backgroundColor = 'transparent';
        seventhButton.style.borderColor = '#FFFFFF';
        seventhButton.style.color = '#FFFFFF';

        const btnText = seventhButton.querySelector('.btn-text');
        if (btnText) {
            btnText.style.color = '#FFFFFF';
        }

        const btnIcon = seventhButton.querySelector('.new-shop-btn-icon');
        if (btnIcon) {
            btnIcon.style.borderColor = '#FFFFFF';
            // btnIcon.style.backgroundColor = 'transparent';
        }
        seventhButton.addEventListener('mouseenter', function() {
            seventhButton.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            seventhButton.style.borderColor = '#FFFFFF'; 
            if (btnText) btnText.style.color = '#FFFFFF';
            if (btnIcon) btnIcon.style.borderColor = '#FFFFFF';
        });

        seventhButton.addEventListener('mouseleave', function() {
            seventhButton.style.backgroundColor = 'transparent';
            seventhButton.style.borderColor = '#FFFFFF';
            if (btnText) btnText.style.color = '#FFFFFF';
            if (btnIcon) btnIcon.style.borderColor = '#FFFFFF';
        });

    } else {
        console.warn('none');
    }
});

document.querySelectorAll(".product_compatible_accessories_bottom_right").forEach(button => {
  button.addEventListener("click", function() {
    this.classList.toggle("show_more");
    const accessoryList = this.closest(".product_compatible_accessories_block")
                              .querySelector(".product_compatible_accessories_list")
                              .querySelectorAll(".product_compatible_accessorie_more");
    accessoryList.forEach(accessory=>{
    accessory.classList.toggle("hide");
      
    })
  });
});

document.querySelectorAll(".pro_variant_radio").forEach(radio => {
  radio.addEventListener("change", function() {
    const checkboxInput = this.closest(".product_compatible_accessorie")
                             .querySelector(".product_compatible_accessorie_checkbox input");
    checkboxInput.value = this.value;
  });
});

document.querySelectorAll(".compatible_accessorie_checkbox").forEach(checkbox => {
  checkbox.addEventListener("change", function(event) {
    const isChecked = event.target.checked;
    const accessory = this.closest(".product_compatible_accessorie");
    const overlay = accessory?.querySelector(".product_compatible_accessorie_overlay");

    if (isChecked && overlay) {
      overlay.classList.add("product_compatible_accessorie_overlay_show");
      setTimeout(() => {
        overlay.classList.remove("product_compatible_accessorie_overlay_show");
      }, 2000);
    } else if (overlay) {
      overlay.classList.remove("product_compatible_accessorie_overlay_show");
    }

    const selectedCheckboxes = document.querySelectorAll(".compatible_accessorie_checkbox:checked");
 
    const selectedCount = selectedCheckboxes.length;
    const bottomLeftElement = document.querySelector(".product_compatible_accessories_bottom_left");
    if (!bottomLeftElement) return;

    if (selectedCount > 0) {
        let totalPrice = 0
           selectedCheckboxes.forEach((checkbox) => {
             totalPrice += checkbox.getAttribute("data-price")*1
            });
         let discount_price = totalPrice * 0.1
       bottomLeftElement.innerHTML = `<span style="color:rgb(var(--color-sale-off-price));">Already Saved <strong>${Shopify.formatMoney(discount_price)}</strong> ！</span>`;
    
    } else {
      bottomLeftElement.innerHTML = "Buy More Save More";
    }
  });
});
// new shop 优化
// 视频区域动画
 document.addEventListener("DOMContentLoaded", function () {
  // 移动端不执行动画，直接填充文本
  if (window.innerWidth <= 900) {
    document.querySelectorAll(".new-shop-video-title, .new-shop-video-subtitle").forEach(function(line){
      line.innerHTML = line.getAttribute("data-text") || "";
    });
    return;
  }
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
    return;
  const videoSection = document.querySelectorAll(".new-shop-video-section");
  if (!videoSection || videoSection.length === 0) return;
  videoSection.forEach((section) => {
    const title = section.querySelector(".new-shop-video-title");
    const subtitle = section.querySelector(".new-shop-video-subtitle");

    // 直接填充文字内容
    title.innerHTML = title.getAttribute("data-text") || "";
    subtitle.innerHTML = subtitle.getAttribute("data-text") || "";

    const mask = section.querySelector(".new-shop-video-mask");
    const content = section.querySelector(".new-shop-video-content");
    const delayPx = window.innerHeight * 1;
    const scrollLength = window.innerHeight * 1;
    const totalLength = delayPx + scrollLength;
    mask.style.transform = "translateY(100%)";
    
    // 初始显示内容
    content.style.display = "none";

    ScrollTrigger.create({
      trigger: section,
      start: `bottom bottom`,
      end: `bottom+=${totalLength} bottom`,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
      fastScrollEndDelay: 0.1,
      onUpdate: (self) => {
        const progress = self.progress; // 0~1

        let maskProgress =
          Math.min(progress, delayPx / totalLength) / (delayPx / totalLength);
        maskProgress = Math.max(0, Math.min(1, maskProgress));
        mask.style.transform = `translateY(${100 - 100 * maskProgress}%)`;

        // 蒙层未到80%时隐藏内容
        if (maskProgress < 0.8) {
          content.style.display = "none";
        } else {
          content.style.display = "flex";
        }
      },
    });
    window.addEventListener("resize", () => ScrollTrigger.refresh());
  });
});


function initBestSellerSection(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) {
    console.warn("Best Seller section not found:", sectionId);
    return;
  }
  
  // 防止重复初始化
  if (section.dataset.initialized === "true") {
    return;
  }
  
  try {
    // 初始化标签页切换
    const tabs = section.querySelectorAll(".new-shop-best-seller-tab");
    const panels = section.querySelectorAll(".new-shop-best-seller-panel");
  
    tabs.forEach((tab, idx) => {
      tab.addEventListener("click", function () {
        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));
        tab.classList.add("active");
        panels[idx].classList.add("active");
        setTimeout(() => {
          panels[idx].querySelectorAll(".swiper-slide").forEach((slide) => {
            slide.classList.remove("fade-in-up");
            void slide.offsetWidth;
            slide.classList.add("fade-in-up");
          });
        }, 10);
      });
    });
    // 初始化主轮播
    section.querySelectorAll('.new-shop-best-seller-panel-swiper').forEach(function (swiperEl, idx) {
      if (swiperEl.swiper) {
        swiperEl.swiper.destroy();
      }
      
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 24,
        autoHeight: false,
        navigation: {
          nextEl: '.new-shop-best-seller-panel-swiper-next-' + idx,
          prevEl: '.new-shop-best-seller-panel-swiper-prev-' + idx,
        },
        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          600: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          500: {
              slidesPerView: 1.5,
            spaceBetween: 12
          },
          400: {
            slidesPerView: 'auto',
            spaceBetween: 12
          },
          0: {
            slidesPerView: 'auto',
            spaceBetween: 12
          }
        },
        loop: false,
        on: {
          init: function() {
            updateNavigationButtons(this);
          },
          slideChange: function() {
            updateNavigationButtons(this);
          },
          resize: function() {
            updateNavigationButtons(this);
          }
        }
      });
      
      // 更新导航按钮显示状态的函数
      function updateNavigationButtons(swiperInstance) {
        const prevBtn = swiperInstance.el.querySelector('.swiper-button-prev');
        const nextBtn = swiperInstance.el.querySelector('.swiper-button-next');
        
        if (prevBtn) {
          prevBtn.style.display = swiperInstance.isBeginning ? 'none' : 'flex';
        }
        if (nextBtn) {
          nextBtn.style.display = swiperInstance.isEnd ? 'none' : 'flex';
        }
      }
    });
  
    // 标记为已初始化
    section.dataset.initialized = "true";
  } catch (error) {
    console.error("Error initializing Best Seller section:", sectionId, error);
  }
  }
  
  // 页面加载完成后初始化所有Best Seller模块
  document.addEventListener("DOMContentLoaded", function () {
  // 查找所有Best Seller模块并初始化
  const bestSellerSections = document.querySelectorAll(".new-shop-best-seller");
  bestSellerSections.forEach(function (section) {
    const sectionId = section.id;
    if (sectionId) {
      initBestSellerSection(sectionId);
    }
  });
  });
  
  // 监听Shopify主题编辑器的事件
  document.addEventListener("shopify:section:load", function (event) {
  if (event.target.classList.contains("new-shop-best-seller")) {
    const sectionId = event.target.id;
    if (sectionId) {
      initBestSellerSection(sectionId);
    }
  }
  });


function updateSearchModalTop() {
  const header = document.querySelector('header.header');
  const modal = document.querySelector('details[open] > .search-modal');
  if (header && modal) {
    const headerBottom = header.getBoundingClientRect().bottom;
    modal.style.top = `${headerBottom}px`;
  }
}

// 每次 details 打开时设置 top
document.querySelectorAll('details').forEach((detail) => {
  detail.addEventListener('toggle', function () {
    if (this.open) {
      // 必须等下一个 tick 等 modal 出现
      setTimeout(updateSearchModalTop, 0);
    }
  });
});

// 可选：窗口大小变更时重新计算
window.addEventListener('resize', updateSearchModalTop);

document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const target = params.get("scroll");
  if (target) {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
});